import { Box, Typography } from '@mui/material';
import React from 'react';
import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px); 
  }
  to {
    opacity: 1;
    transform: translateY(0); 
  }
`;

// Анимация "сияния" для текста
const sparkle = keyframes`
  0% { opacity: 0.8; }
  50% { opacity: 1; }
  100% { opacity: 0.8; }
`;

// Анимация для падающих снежинок
const snowfall = keyframes`
  0% { transform: translateY(-100px); opacity: 0; }
  50% { opacity: 1; }
  100% { transform: translateY(600px); opacity: 0; }
`;

// Стилизованный компонент для снежинок
const Snowflake = ({ size, left, delay }) => (
  <Box
    sx={{
      position: 'absolute',
      top: '-5px',
      left: `${left}%`,
      fontSize: `${size}px`,
      color: 'white',
      opacity: 0.8,
      animation: `${snowfall} 10s linear ${delay}s infinite`,
    }}
  >
    🌸
  </Box>
);

const BannerText = () => {
  return (
    <Box
      sx={{
        position: 'relative', // Для снежинок
        mb: 4,
        maxWidth: '100%',
        bgcolor: 'rgba(0, 0, 0, 0.6)',
        color: 'white',
        padding: {
          xs: '20px',
          sm: '30px',
          md: '40px',
        },
        borderRadius: '12px',
        boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        animation: `${fadeIn} 1s ease-in-out`,
        backdropFilter: 'blur(8px)',
      }}
    >
      {/* Снежинки */}
      {Array.from({ length: 20 }).map((_, index) => (
        <Snowflake
          key={index}
          size={Math.random() * 15 + 10} // Размер снежинок от 10 до 25 пикселей
          left={Math.random() * 100} // Позиция по горизонтали
          delay={Math.random() * 10} // Задержка для случайного падения
        />
      ))}

      <Typography
        variant="h2"
        sx={{
          fontWeight: 'bold',
          fontSize: {
            xs: '1.2rem',
            sm: '2rem',
            md: '2.5rem',
          },
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
          animation: `${sparkle} 2s ease-in-out infinite`, // Блестящая анимация
        }}
      >
        Добро пожаловать в <span style={{ color: '#aa5adc' }}>Game Zone</span>
      </Typography>
      <Typography
        variant="h5"
        sx={{
          fontSize: {
            xs: '1.2rem',
            sm: '1.5rem',
            md: '1.25rem',
          },
          textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
          animation: `${sparkle} 2.5s ease-in-out infinite`, // Легкая блестящая анимация
        }}
      >
        Наслаждайтесь играми <br />
        <span style={{ fontWeight: 'bold', color: '#aa5adc' }}>PS4 & PS5</span>
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: {
            xs: '1.2rem',
            sm: '1.5rem',
            md: '1.25rem',
          },
          color: '#e0e0e0',
          fontWeight: 'bold',
          letterSpacing: 1.2,
        }}
      >
        График работы: <br />{' '}
        <span style={{ color: '#aa5adc' }}>с 10:00 до 07:00</span>
      </Typography>
      {/* Address Text */}
      <a
        href="https://2gis.kg/bishkek/directions/points/74.587996,42.867305" // Ссылка для построения маршрута
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }} // Remove underline from the link
      >
        <Typography
          variant="body1"
          sx={{
            color: '#ffffff', // Dark muted color
            mt: 4, // Larger top margin for spacing
            fontWeight: '600',
            letterSpacing: '0.8px',
            textShadow: '1px 1px 5px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            fontSize: '1.4rem',
            '::before': {
              content: '""',
              display: 'block',
              width: '50%',
              height: '2px',
              backgroundColor: '#ced4da',
              position: 'absolute',
              top: '-12px', // Position the line above the text
              left: '25%', // Center the line
            },
          }}
        >
          Бишкек, ул. Манаса, 5
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'transform 0.3s ease', // Add transition for the Box
            '&:hover': {
              transform: 'scale(1.01)', // Scale up on hover
            },
          }}
        >
          <Typography color="#b053ee">Построить маршрут</Typography>
        </Box>
      </a>
    </Box>
  );
};

export default BannerText;
